import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import storage from '../storage';
import { TOKEN } from '../constants/cookies';
import { defaultRoute } from '../routes/default-route-redirect';

const isAuthenticated =
  storage.getItem(TOKEN) !== undefined &&
  storage.getItem(TOKEN) &&
  storage.getItem(TOKEN) !== ''
    ? true
    : false;

const GuestRoute = ({ component: Component, ...restProps }) => (
  <Route
    {...restProps}
    render={(props) =>
      !isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect to={`/${defaultRoute}`} />
      )
    }
  />
);

GuestRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default GuestRoute;
